module.exports = __webpack_public_path__ + "img/rapid-icon.404c7dd1.svg";